import * as z from "zod";

export const FreightCompanySchema = z.object({
  id: z.string().uuid(),
  company_name: z
    .string()
    .min(1, "Company name is required")
    .max(255, "Company name must be less than 255 characters"),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const CompanyFreightSchema = z.object({
  id: z.string().uuid(),
  company_id: z.string().uuid(),
  freight_id: z.string().uuid(),
  number: z
    .string()
    .max(100, "Number must be less than 100 characters")
    .optional(),
  tag: z.string().max(100, "Tag must be less than 100 characters").optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createFreightCompanySchema = FreightCompanySchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateFreightCompanySchema = FreightCompanySchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});

export const createCompanyFreightSchema = CompanyFreightSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateCompanyFreightSchema = CompanyFreightSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});
